import React, { useState } from 'react';
import { useTheme } from '../context/ThemeContext';
import SwipeCard from './SwipeCard';
import { FeedbackOverlay } from './GameElements';

export default function WelcomeScreen({ onClose }) {
  const { colors } = useTheme();
  const [showFeedback, setShowFeedback] = useState(false);
  const [lastCorrect, setLastCorrect] = useState(null);
  const [imgError, setImgError] = useState(false);

  const styles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: '#1a202c',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 2000,
    },
    instruction: {
      position: 'fixed',
      bottom: '20px',
      left: '50%',
      transform: 'translateX(-50%)',
      color: 'white',
      fontSize: '1.1em',
      textAlign: 'center',
      padding: '12px 24px',
      borderRadius: '30px',
      background: 'rgba(255, 255, 255, 0.1)',
      zIndex: 2001,
      whiteSpace: 'nowrap',
    },
    logo: {
      width: '80%',
      maxWidth: '192px',
      height: 'auto',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      objectFit: 'contain'
    },
    fallbackText: {
      fontSize: '1.8em',
      fontWeight: 'bold',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '90%',
      textAlign: 'center',
      color: '#fff'
    }
  };

  const handleSwipe = async (isCorrect) => {
    setLastCorrect(true); // Always show correct feedback
    setShowFeedback(true);
    await new Promise(resolve => setTimeout(resolve, 300));
    setShowFeedback(false);
    onClose();
  };

  const renderLogo = () => {
    if (imgError) {
      return <div style={styles.fallbackText}>Quick Study!</div>;
    }

    return (
      <img
        src="/store-assets/android-chrome-512x512.png"
        onError={(e) => {
          e.currentTarget.onerror = null; // Prevent infinite loop
          setImgError(true);
        }}
        alt="Quick Study Logo"
        style={styles.logo}
      />
    );
  };

  return (
    <>
      <div style={styles.overlay}>
        <FeedbackOverlay isCorrect={lastCorrect} show={showFeedback} />
        <SwipeCard
          word={renderLogo()}
          incorrect="← left swipe"
          answer="right swipe →"
          onSwipe={handleSwipe}
          isVisible={true}
        />
      </div>
      <div style={styles.instruction}>Click on gear to change or add flashcard topic</div>
    </>
  );
}
